import React from "react";

type ChunkErrorBoundaryProps = {
  children: React.ReactNode;
};

type ChunkErrorBoundaryState = {
  hasError: boolean;
};

export class ChunkErrorBoundary extends React.Component<ChunkErrorBoundaryProps, ChunkErrorBoundaryState> {
  constructor(props: ChunkErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    if (error?.name === "ChunkLoadError" || /Loading chunk [\d]+ failed/i.test(error?.message || "")) {
      return { hasError: true };
    }
    return null;
  }

  componentDidCatch(error: any, info: any) {
    console.error("Error caught in ChunkErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      window.location.reload();
      return null;
    }

    return this.props.children;
  }
}
